import requests from "./httpService";


const EventServices = {

    getEvent: async (page = 1, limit = 20) => {
        return requests.get(`/event/all?page=${page}&limit=${limit}`);
    },
getEventBooking: async (
    page = 1,
    limit = 20,
    eventId = "",
    paymentStatus = "",
    bookingStatus = "",
    checkInStatus = ""
) => {
    return requests.get(
        `/event-booking/admin/all-bookings?page=${page}&limit=${limit}&paymentStatus=${paymentStatus}&status=${bookingStatus}&checkInStatus=${checkInStatus}&eventId=${eventId}`
    );
},
getEventBookingCSV: async (
    page = 1,
    limit = 20,
    eventId = "",
    searchQuery = "",
    paymentStatus = "",
    bookingStatus = "",
    checkInStatus = ""
) => {
    return requests.get(
        `/event-booking/admin/export-bookings-csv?page=${page}&limit=${limit}&search=${searchQuery}&paymentStatus=${paymentStatus}&status=${bookingStatus}&checkInStatus=${checkInStatus}&eventId=${eventId}`,
        {
            responseType: "blob",
        }
    );
},

    getActiveEvents: async () => {
        return requests.get(`/event/active`);
    },

    getEventById: async (id) => {
        return requests.get(`/event/${id}`);
    },

    createEvent: async (body) => {
        return requests.post(`/event/create`, body);
    },

    updateEventStatus: async (id, body) => {
        return requests.put(`/event/${id}/status`, body);
    },

    updateEvent: async (id, body) => {
        return requests.put(`/event/${id}`, body);
    },

    deleteEvent: async (id) => {
        return requests.delete(`/event/${id}`);
    },
};

export default EventServices;